// extracted by mini-css-extract-plugin
module.exports = {"container":"sidebarWrapper_container__2Sqob","left":"sidebarWrapper_left__2NQeK","right":"sidebarWrapper_right__3x4Js"};